import { TabPanel, TabView } from "primereact/tabview";
import { useSearchParams } from "react-router-dom";

import EdiConversionFilesTable from "./components/EdiConversionFilesTable";

export function Underpayments() {
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <TabView
      className="w-full"
      activeIndex={Number(searchParams.get("tab")) || 0}
      onTabChange={(e) => setSearchParams({ tab: e.index.toString() })}
    >
      <TabPanel header="EDI Conversion Files">
        <EdiConversionFilesTable />
      </TabPanel>
    </TabView>
  );
}
